import React from "react";
import locale from "@bonliva-crm/locale";
import { FilterWithFavouriteProps } from "../utils/filters-record-types";
import { MultiSelectFilter } from "./_common/multi-select-filter";
import { BookingKitType } from "@bonliva-crm/shared";

type Option = { label: string; value: string | null };

export type KitTypeFilterProps = {
  label?: string;
  options?: Option[];
} & FilterWithFavouriteProps;

export const KitTypeFilter = ({ label, options, ...props }: KitTypeFilterProps) => {
  const title = label ?? locale.kitTableColumnType.Type;

  const _options = [
    BookingKitType.Complete,
    BookingKitType.Compensation,
    BookingKitType.AccruedIncome,
    BookingKitType.AccruedCost,
    BookingKitType.PreviouslyAccruedIncome,
    BookingKitType.PreviouslyAccruedCost,
    BookingKitType.Credit,
    BookingKitType.SickPay
  ].map((status) => ({
    label: locale.bookingKitType[status],
    value: status
  }));

  return <MultiSelectFilter label={title} options={_options} {...props} />;
};
